export default class FontLoader {

	constructor()
	{
		this.loaded = []; // List of Font ID's already loaded...
	}

	/**
	 * Loader function that helps to trigger a callback when fonts are loaded in.
	 *
	 * @param font
	 * @param onActive
	 * @param onLoading
	 * @param onInactive
	 */
	load(font, onActive, onInactive, onLoading)
	{

		if (!font) {
			return false;
		}

		if (this.isLoaded(font.id)) {
			return onActive();
		}

		let css =
			'@font-face {' +
			'font-family: "' + font.name + '";' +
			'src: url(\'' + font.url + '\') format(\'truetype\');' +
			'} ';

		// Declare css class if custom font
		if (font.custom) {
			css +=
				'.font-' + font.hash.substring(0, 4) + ' {' +
				'} ';
		}

		// Prepend css font style to head
		let e = document.createElement('style');
		e.innerHTML = css;
		document.head.insertBefore(e, document.head.childNodes[0]);

		let settings = {
			custom: {
				families: [font.name]
			},
			loading: function () {
			},
			active: function () {
			},
			inactive: function () {
			},
			fontloading: (familyName, fvd) => {
				onLoading && onLoading();
			},
			fontactive: (familyName, fvd) => {
				this.loaded.push(font.id);
				onActive && onActive();
			},
			fontinactive: (familyName, fvd) => {
				onInactive && onInactive();
			},
			timeout: 10000   // in milliseconds, if font has not loaded within 10 seconds, throw exception
		};

		// The Google API Script will only be loaded once...
		ScriptLoader.load('ajax.googleapis.com/ajax/libs/webfont/1.6.16/webfont.js', () => {
			WebFont.load(settings);
		}, true);
	}

	isLoaded(id)
	{
		return this.loaded.indexOf(id) >= 0;
	}
}